import React, { useState } from 'react';
import { Grid } from "@material-ui/core";
import SelecaoMultiplaAuto from "../../../shared/components/SelecaoMultiplaAuto";
import TextFieldPesquisa from "../../../shared/components/TextFieldPesquisa";
import useDebounce from "../../../shared/customHooks/useDebounce";

const FiltrosAmostrasDisponiveis = ({
    filtros,
    handleChangeFiltros,
    tiposOpcoes
}) => {
    const [buscaLocal, setBuscaLocal] = useState(filtros.busca || "");
    const handleChangeBuscaDebouce = useDebounce(handleChangeFiltros, 600);
    
    const handleChangeBuscaLocal = (event) => {
        const novaBusca = event.target.value;
        setBuscaLocal(novaBusca);

        if (novaBusca.length > 2 || novaBusca.length === 0){
            handleChangeBuscaDebouce({...filtros, busca: novaBusca});
        }
    }

    return (
        <Grid container spacing={3}>
            <Grid item xs={7}>
                <TextFieldPesquisa
                    autoFocusEnable={true}
                    id="buscarAmostras"
                    label="Buscar por amostra, paciente ou pedido"
                    value={buscaLocal}
                    onChange={handleChangeBuscaLocal}
                    iconeSeparador={true}
                />
            </Grid>

            <Grid item xs={5}>
                <SelecaoMultiplaAuto
                    options={tiposOpcoes}
                    getOptionLabel={opcao => opcao.descricao}
                    getOptionValue={opcao => opcao.codigo}
                    handleChange={opcao => handleChangeFiltros({...filtros, tipos: opcao})}
                    code={filtros.tipos}
                    label="Filtrar por tipo"
                    isClearable
                    multiple
                    returnFullObject
                />
            </Grid>
        </Grid>
    );
}

export default FiltrosAmostrasDisponiveis;